import { render } from "./historyLayout.vue?vue&type=template&id=642d91ee&scoped=true"
const script = {}

import "./historyLayout.vue?vue&type=style&index=0&id=642d91ee&scoped=true&lang=css"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642d91ee"]])

export default __exports__